/**
 * Bola no full banner — chute na caixa, recuo, quiques no chão e saída pela esquerda.
 */
(function () {
  if (typeof window === 'undefined') return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  var PAUSE_MS = 2400;
  var SHAKE_MS = 480;
  var KICK_MS = 680;
  var RECOIL_MS = 260;
  var GRAVITY = 1750;
  var RESTITUTION = 0.62;
  var FRICTION = 0.9;
  var MIN_BOUNCE_VY = 95;
  var HOLE_DROP_VY = 200;
  var HOLE_GRAVITY = 2400;
  var ROLL_SPEED = -195;

  function initHero(hero) {
    if (!hero || hero.dataset.copaBallReady === '1') return;
    if (hero.dataset.copaBallEnabled === 'false') return;

    var stage = hero.querySelector('[data-copa-ball-stage]');
    var ball = hero.querySelector('[data-copa-ball]');
    var box = hero.querySelector('[data-copa-hero-box]');
    var boxFrame = box ? box.querySelector('.copa-hero-banner__visual-frame') : null;
    var video = hero.querySelector('[data-copa-ball-video]');
    if (!stage || !ball || !box) return;

    hero.dataset.copaBallReady = '1';

    var rafId = null;
    var kickAnim = null;
    var recoilAnim = null;
    var pauseTimer = null;
    var shakeTimer = null;
    var dismissTimer = null;
    var phaseStarted = false;
    var physicsActive = false;
    var isFalling = false;
    var scrollHandler = null;
    var lastStageW = stage.clientWidth;

    function unbindScrollDismiss() {
      if (!scrollHandler) return;
      window.removeEventListener('scroll', scrollHandler);
      scrollHandler = null;
    }

    function bindScrollDismiss() {
      if (scrollHandler) return;
      scrollHandler = function () {
        if (!isFalling) return;
        if (shouldDismissOnScroll()) dismissBallSubtle();
      };
      window.addEventListener('scroll', scrollHandler, { passive: true });
    }

    function shouldDismissOnScroll() {
      var wrap = hero.closest('.shopify-section') || hero;
      var r = wrap.getBoundingClientRect();
      var ballR = ball.getBoundingClientRect();
      return (
        r.bottom < ballSize() * 0.35 ||
        r.top > window.innerHeight - ballSize() * 0.5 ||
        ballR.top > window.innerHeight + 8 ||
        ballR.bottom < -ballSize() * 0.35
      );
    }

    function dismissBallSubtle() {
      if (!isFalling && !physicsActive) return;
      unbindScrollDismiss();
      isFalling = false;
      physicsActive = false;
      phaseStarted = false;

      if (rafId) {
        cancelAnimationFrame(rafId);
        rafId = null;
      }
      if (pauseTimer) {
        window.clearTimeout(pauseTimer);
        pauseTimer = null;
      }

      ball.style.transition = 'opacity 0.34s ease-out, visibility 0.34s ease-out';
      ball.style.opacity = '0';
      ball.style.visibility = 'hidden';

      if (dismissTimer) window.clearTimeout(dismissTimer);
      dismissTimer = window.setTimeout(function () {
        dismissTimer = null;
        ball.style.transition = '';
        ball.style.opacity = '';
        ball.style.visibility = '';
        runCycle();
      }, 360);
    }

    function cancelAll() {
      phaseStarted = false;
      physicsActive = false;
      isFalling = false;
      unbindScrollDismiss();
      if (dismissTimer) {
        window.clearTimeout(dismissTimer);
        dismissTimer = null;
      }
      if (rafId) {
        cancelAnimationFrame(rafId);
        rafId = null;
      }
      if (kickAnim) {
        kickAnim.cancel();
        kickAnim = null;
      }
      if (recoilAnim) {
        recoilAnim.cancel();
        recoilAnim = null;
      }
      if (pauseTimer) {
        window.clearTimeout(pauseTimer);
        pauseTimer = null;
      }
      ball.getAnimations().forEach(function (a) {
        a.cancel();
      });
    }

    function commitTransform(x, y, rot, scale) {
      ball.getAnimations().forEach(function (a) {
        a.cancel();
      });
      ball.style.transform = tf(x, y, rot, scale);
    }

    function ballSize() {
      var w = stage.clientWidth;
      if (w < 560) return 46;
      if (w < 992) return 58;
      return 70;
    }

    function getMarqueeSection(heroEl) {
      if (!heroEl) return null;
      var heroWrap = heroEl.closest('.shopify-section') || heroEl.parentElement;
      if (!heroWrap || !heroWrap.nextElementSibling) return null;
      return heroWrap.nextElementSibling.querySelector('section');
    }

    function resolveFloorTop(stageR, size, marqueeSec) {
      var floorTop = stageR.height - size - 8;
      if (marqueeSec) {
        var mR = marqueeSec.getBoundingClientRect();
        floorTop = mR.top - stageR.top - size + 2;
      }
      return Math.max(8, Math.min(floorTop, stageR.height - size));
    }

    function resolvePlatformLeft(heroEl, stageR, size, marqueeSec) {
      var platformLeft = stageR.width * 0.1;

      if (marqueeSec) {
        var track =
          marqueeSec.querySelector('.text-horizontal-running') ||
          marqueeSec.querySelector('.container') ||
          marqueeSec.querySelector('.full-width');
        var edgeEl = track || marqueeSec;
        var eR = edgeEl.getBoundingClientRect();
        platformLeft = eR.left - stageR.left;
      }

      return Math.max(0, Math.min(platformLeft, stageR.width - size * 2));
    }

    function resolveHoleExitY(stageR, size, heroEl, marqueeSec) {
      var exitY = stageR.height + size * 1.5;

      if (marqueeSec) {
        var mR = marqueeSec.getBoundingClientRect();
        exitY = mR.bottom - stageR.top + size;
      }

      var heroWrap = heroEl ? heroEl.closest('.shopify-section') : null;
      if (heroWrap && heroWrap.nextElementSibling) {
        var nextR = heroWrap.nextElementSibling.getBoundingClientRect();
        exitY = Math.max(exitY, nextR.bottom - stageR.top + size);
      }

      var viewportExit = window.innerHeight - stageR.top + size * 1.15;
      exitY = Math.max(exitY, viewportExit);

      return exitY + size * 0.35;
    }

    function onPlatform(arena, x) {
      return x + arena.size * 0.15 >= arena.platformLeft;
    }

    function getArena() {
      var stageR = stage.getBoundingClientRect();
      var target = boxFrame || box;
      var targetR = target.getBoundingClientRect();
      var size = ballSize();
      var heroEl = stage.closest('[data-copa-hero]');
      var marqueeSec = getMarqueeSection(heroEl);
      var floorY = resolveFloorTop(stageR, size, marqueeSec);
      var platformLeft = resolvePlatformLeft(heroEl, stageR, size, marqueeSec);
      var holeExitY = resolveHoleExitY(stageR, size, heroEl, marqueeSec);

      var boxLeft = targetR.left - stageR.left;
      var boxTop = targetR.top - stageR.top;
      var boxH = targetR.height;

      var impactX = boxLeft - size * 0.28;
      var impactY = boxTop + boxH * 0.5;

      return {
        size: size,
        floorY: floorY,
        platformLeft: platformLeft,
        holeExitY: holeExitY,
        start: {
          x: -size * 1.15,
          y: floorY,
        },
        impact: { x: impactX, y: impactY },
        recoil: {
          x: impactX - size * 0.55,
          y: impactY - size * 0.12,
        },
      };
    }

    function shakeBox() {
      box.classList.remove('copa-hero-box-shake');
      void box.offsetWidth;
      box.classList.add('copa-hero-box-shake');
      if (shakeTimer) window.clearTimeout(shakeTimer);
      shakeTimer = window.setTimeout(function () {
        box.classList.remove('copa-hero-box-shake');
      }, SHAKE_MS);
    }

    function playVideo() {
      if (!video) return;
      video.muted = true;
      video.playsInline = true;
      var p = video.play();
      if (p && typeof p.catch === 'function') p.catch(function () {});
    }

    function rollSpinDeg(vx, radius, dt) {
      return (vx / radius) * (180 / Math.PI) * dt;
    }

    function tf(x, y, rot, scale) {
      return (
        'translate3d(' +
        x.toFixed(2) +
        'px,' +
        y.toFixed(2) +
        'px,0) rotate(' +
        rot.toFixed(2) +
        'deg) scale(' +
        scale +
        ')'
      );
    }

    function runPhysicsExit(arena, x, y, vx, vy, rot) {
      var size = arena.size;
      var bounceCount = 0;
      var rolling = false;
      var falling = false;
      var lastT = null;

      function resetLater() {
        pauseTimer = window.setTimeout(runCycle, PAUSE_MS);
      }

      function leavePlatform() {
        if (falling) return;
        falling = true;
        isFalling = true;
        rolling = false;
        if (vy < HOLE_DROP_VY) vy = HOLE_DROP_VY;
        bindScrollDismiss();
      }

      function tick(now) {
        if (!lastT) lastT = now;
        var dt = Math.min(0.032, (now - lastT) / 1000);
        lastT = now;

        if (falling && shouldDismissOnScroll()) {
          dismissBallSubtle();
          return;
        }

        var supported = onPlatform(arena, x);

        if (rolling && !supported) {
          leavePlatform();
        }

        if (!rolling || falling) {
          vy += (falling ? HOLE_GRAVITY : GRAVITY) * dt;
        }

        x += vx * dt;
        y += vy * dt;

        var radius = size * 0.5;

        if (supported && !falling && y >= arena.floorY) {
          y = arena.floorY;

          if (!rolling && vy > 30) {
            vy = -vy * RESTITUTION;
            vx *= FRICTION;
            bounceCount += 1;
            rot += rollSpinDeg(vx, radius, dt);

            if (Math.abs(vy) < MIN_BOUNCE_VY) {
              rolling = true;
              vy = 0;
              vx = ROLL_SPEED;
            }
          } else {
            rolling = true;
            vy = 0;
            vx = ROLL_SPEED;
          }
        }

        if (rolling && supported && !falling) {
          y = arena.floorY;
          vy = 0;
          vx = ROLL_SPEED;
          rot += rollSpinDeg(vx, radius, dt);
        } else if (!falling) {
          rot += rollSpinDeg(vx, radius, dt);
        }

        if (falling) {
          vx *= 0.997;
          rot += rollSpinDeg(vx, radius, dt);
        }

        commitTransform(x, y, rot, 1);

        if (falling && y >= arena.holeExitY) {
          isFalling = false;
          unbindScrollDismiss();
          cancelAnimationFrame(rafId);
          rafId = null;
          physicsActive = false;
          resetLater();
          return;
        }

        if (!falling && x < -size * 1.55) {
          unbindScrollDismiss();
          cancelAnimationFrame(rafId);
          rafId = null;
          physicsActive = false;
          resetLater();
          return;
        }

        rafId = requestAnimationFrame(tick);
      }

      physicsActive = true;
      commitTransform(x, y, rot, 1);
      rafId = requestAnimationFrame(tick);
    }

    function startRecoilThenPhysics(arena) {
      if (phaseStarted) return;
      phaseStarted = true;

      commitTransform(arena.impact.x, arena.impact.y, 720, 1.06);

      recoilAnim = ball.animate(
        [
          { transform: tf(arena.impact.x, arena.impact.y, 720, 1.06) },
          { transform: tf(arena.recoil.x, arena.recoil.y, 640, 1) },
        ],
        { duration: RECOIL_MS, easing: 'ease-out', fill: 'forwards' }
      );

      recoilAnim.onfinish = function () {
        recoilAnim = null;
        commitTransform(arena.recoil.x, arena.recoil.y, 640, 1);
        runPhysicsExit(arena, arena.recoil.x, arena.recoil.y, -400, 380, 640);
      };

      window.setTimeout(function () {
        if (recoilAnim) {
          recoilAnim.cancel();
          recoilAnim = null;
          commitTransform(arena.recoil.x, arena.recoil.y, 640, 1);
          runPhysicsExit(arena, arena.recoil.x, arena.recoil.y, -400, 380, 640);
        }
      }, RECOIL_MS + 60);
    }

    function runCycle() {
      cancelAll();

      var arena = getArena();
      var size = arena.size;
      ball.style.width = size + 'px';
      ball.style.height = size + 'px';

      commitTransform(arena.start.x, arena.start.y, 0, 0.88);

      kickAnim = ball.animate(
        [
          { transform: tf(arena.start.x, arena.start.y, 0, 0.88) },
          { transform: tf(arena.impact.x, arena.impact.y, 720, 1.06) },
        ],
        { duration: KICK_MS, easing: 'linear', fill: 'forwards' }
      );

      window.setTimeout(shakeBox, Math.round(KICK_MS * 0.9));

      kickAnim.onfinish = function () {
        kickAnim = null;
        startRecoilThenPhysics(arena);
      };

      window.setTimeout(function () {
        if (!phaseStarted) startRecoilThenPhysics(arena);
      }, KICK_MS + 100);
    }

    playVideo();

    if (document.readyState === 'complete') {
      runCycle();
    } else {
      window.addEventListener('load', runCycle, { once: true });
    }

    var resizeTimer;
    window.addEventListener('resize', function () {
      var w = stage.clientWidth;
      if (Math.abs(w - lastStageW) < 3) return;
      lastStageW = w;
      if (physicsActive || kickAnim || recoilAnim || isFalling) return;
      window.clearTimeout(resizeTimer);
      resizeTimer = window.setTimeout(runCycle, 220);
    });

    document.addEventListener('visibilitychange', function () {
      if (document.hidden) {
        cancelAll();
        if (video) video.pause();
      } else {
        playVideo();
        runCycle();
      }
    });
  }

  function boot() {
    document.querySelectorAll('[data-copa-hero]').forEach(initHero);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', boot);
})();
